import { Injectable } from '@angular/core';
import {
  FulfillmentOrderConfigApiService,
  GetFulfillmentOrderConfigRequest,
  GetFulfillmentOrderConfigResponse,
  ReleaseType,
} from '@vendasta/marketplace-apps';
import { Order as SalesOrder } from '@vendasta/sales-orders';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrderSubmittedService {
  private _salesOrder$$: BehaviorSubject<SalesOrder> = new BehaviorSubject(null);
  private _salesOrder$: Observable<SalesOrder> = this._salesOrder$$.asObservable();

  constructor(private fulfillmentOrderConfigService: FulfillmentOrderConfigApiService) {}

  set salesOrder(salesOrder: SalesOrder) {
    this._salesOrder$$.next(salesOrder);
  }

  get salesOrder$(): Observable<SalesOrder> {
    return this._salesOrder$;
  }

  someItemsHaveFulfillmentForms(appIds: string[]): Observable<boolean> {
    if (!appIds || appIds.length === 0) {
      return of(false);
    }
    return forkJoin(
      appIds.map((appId) =>
        this.fulfillmentOrderConfigService.getFulfillmentOrderConfig(
          new GetFulfillmentOrderConfigRequest({
            appId,
            release: ReleaseType.RELEASE_TYPE_PUBLISHED,
            projectionFilter: {
              includeFormConfig: true,
            },
          }),
        ),
      ),
    ).pipe(
      map((resp: GetFulfillmentOrderConfigResponse[]) =>
        resp.reduce((prev, curr) => prev || curr?.config?.usesFulfillmentForm, false),
      ),
    );
  }

  getTotalItemsThatHaveFulfillmentForms(appIds: string[]): Observable<number> {
    if (!appIds || appIds.length === 0) {
      return of(0);
    }
    return forkJoin(
      appIds.map((appId) =>
        this.fulfillmentOrderConfigService.getFulfillmentOrderConfig(
          new GetFulfillmentOrderConfigRequest({
            appId,
            release: ReleaseType.RELEASE_TYPE_PUBLISHED,
            projectionFilter: {
              includeFormConfig: true,
            },
          }),
        ),
      ),
    ).pipe(
      map((resp: GetFulfillmentOrderConfigResponse[]) => {
        return resp.reduce((prev, curr) => {
          if (curr?.config?.usesFulfillmentForm) {
            return prev + 1;
          }
          return prev;
        }, 0);
      }),
    );
  }
}
